import {
  getInitialState,
} from '@/creditflowresearch/application/Bonds/BondsFiltersContext/helpers';
import { useFiltersContext } from '@/creditflowresearch/application/FiltersContext';
import { BONDS_STORE_NAME } from '@/creditflowresearch/application/Bonds/constants';
import FooterContainer from './BondsSidebarFooterContainer';
import TagsContainer from './BondsSidebarTagsContainer';
import { filtersKeys } from './constants';
import DatePeriodContainer from './Sections/DatePeriodContainer';
import SectionsContainer from './Sections/SectionsContainer';
import createFiltersStore from '@framework/ui/Organisms/Filters/createFiltersStore';
import FinsightSidebar from '@/creditflowresearch/ui/common/components/FinsightSidebar/FinsightSidebar';
import { useFiltersContext as useFilters } from '@framework/ui/Organisms/Filters/FiltersContext';
import { useBondsFiltersContext } from '@/creditflowresearch/application/Bonds/BondsFiltersContext';

const BondsSideBarContainer = (props) => {
  const { handlePageChange } = useFiltersContext();
  const { filtersUpdate, getFilters } = useFilters();

  const {
    dateFromMin,
    appliedFilters,
    isFetching,
    setFiltersPayload,
    applyFilter: applyFilterAction,
    fetchFilter: fetchFilterAction,
    resetFilters: resetFiltersAction,
    setAppliedFilters,
  } = useBondsFiltersContext();

  const filters = getFilters(BONDS_STORE_NAME);

  const onFetchFilters = async () => {
    handlePageChange(1);
    fetchFilterAction(filters);
  };

  const onApplyFilters = async () => {
    handlePageChange(1);
    applyFilterAction(filters);
    fetchFilterAction(filters);
  };

  const onResetFilters = async () => {
    handlePageChange(1);
    resetFiltersAction(filtersUpdate);
  };

  return (
    <FinsightSidebar
      { ...props }
      filters={ filters }
      isFetching={ isFetching }
      appliedFilters={ appliedFilters }
      dateFromMin={ dateFromMin }
      onFilterApply={ onApplyFilters }
      fetchFilter={ onFetchFilters }
      resetFilters={ onResetFilters }
      getInitialState={ getInitialState }
      payloadChange={ (v) => setFiltersPayload(v) }
      appliedFiltersChange={ (v) => setAppliedFilters(v) }
      FooterContainer={ FooterContainer }
      TagsContainer={ TagsContainer }
      DatePeriodContainer={ DatePeriodContainer }
      SectionsContainer={ SectionsContainer }
      filtersKeys={ filtersKeys }
    />
  );
};

export default createFiltersStore({ filterName: BONDS_STORE_NAME })(BondsSideBarContainer);
